import {doGet} from './http.service';
import {Page} from '../types/Page';
import {ScheduledLog} from '../types/ScheduledLog';
import {sanitizeFilterObject} from './http.service';

export interface ScheduledLogFilter {
    page: number;
    size: number;
    sortKey: string;
    sortOrder: 'asc' | 'desc';
    createdAtFrom?: number;
    createdAtTo?: number;
}

export function loadScheduledLogs(filter: ScheduledLogFilter) {
    const params = sanitizeFilterObject({...filter});
    return doGet<Page<ScheduledLog>>('/scheduled-logs', {params});
}
